module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_11-404a83ad6a1fa60e125506032eff4f64.png";